<template>
  <DetailContainer>
    <PageHeader
      slot="page-header"
      showBack
      showBreadcrumb
      @back="$router.push({ name: 'Product' })"
    >
      <div style="float: right;">
        <hl-button type="border" @click="handleCancel">{{ $t('Common.cancel') }}</hl-button>
        <hl-button @click="handlePublish" :loading="publishLoading" v-if="publishRole">{{
          $t('Common.publish')
        }}</hl-button>
      </div>
    </PageHeader>
    <div slot="top" class="info">
      <div class="info-header">
        <h3>{{ productInfo.name | format }}</h3>
        <hl-status
          :iconClass="(enbaleDisableStatus[productInfo.status] || {})['iconClass']"
          :color="(enbaleDisableStatus[productInfo.status] || {})['color']"
          :title="productInfo.statusName"
        ></hl-status>
      </div>
      <div class="info-tag">
        <hl-tag
          plain
          :color="(productTypeTag[productInfo.type] || {})['color']"
          :borderColor="(productTypeTag[productInfo.type] || {})['color']"
        >
          {{ productInfo.typeName }}
        </hl-tag>
        <hl-tag plain :color="blueColor" :borderColor="blueColor">
          {{ productInfo.networkingModeName }}
        </hl-tag>
      </div>
    </div>
    <div class="bottom-header">
      <div class="left">
        <h3>{{ $t('Product.funcDef') }}</h3>
        <Select
          :query="
            `${$api.product.product_tsl_version_select}?productKey=${productKey}&history=false`
          "
          :labelOptions="{
            key: 'name',
            value: 'name'
          }"
          v-model="version"
          :placeholder="$t('Product.historyVersion')"
          @input="onVersionChange"
        >
        </Select>
      </div>
      <div class="opts">
        <el-upload
          class=""
          action=""
          :show-file-list="false"
          :http-request="handleImport"
          v-if="importRole"
        >
          <hl-button :loading="importLoading">{{ $t('Common.importData') }}</hl-button>
        </el-upload>
        <hl-button type="secondary" @click="handleAdd" v-if="addRole">{{
          $t('Product.addFunc')
        }}</hl-button>
      </div>
    </div>
    <Alert>
      {{ $t('Product.tips4') }}
    </Alert>
    <CommonTable
      ref="table"
      :data="tableData"
      :total="total"
      :operation="operation"
      @operation="handleOperation"
      :table-json="tablejson"
      :needPagination="false"
    >
    </CommonTable>

    <ProductFunctionEdit
      v-if="visible"
      :visible.sync="visible"
      :row="row"
      :tslVersionId="tslVersionId"
      @refresh="search"
    />
    <ProductFunctionDetail
      v-if="detailVisible"
      :visible.sync="detailVisible"
      :row="row"
      :tslVersionId="tslVersionId"
    />
  </DetailContainer>
</template>

<script>
import DetailContainer from '@/components/DetailContainer/index'
import Status from '@/components/CommonTable/Status'
import Tag from '@/components/CommonTable/Tag'
import Alert from '@/components/Alert'
import Select from '@/components/CommonForm/Select'
import ProductFunctionEdit from './Tsl/ProductFunctionEdit'
import ProductFunctionDetail from './Tsl/ProductFunctionDetail'

import { format, formatTime } from '@/utils/utils'
import { enbaleDisableStatus } from '@/config/status'
import { productTypeTag } from '@/config/tag'
import { getRoleByOperationCode, getRoute } from '@/authorized'

import { blueColor } from '@/style/var.scss'

import tablejson from './Model/Tablejson.TSL'

export default {
  components: {
    DetailContainer,
    'hl-status': Status,
    'hl-tag': Tag,
    Alert,
    Select,
    ProductFunctionEdit,
    ProductFunctionDetail
  },
  data() {
    return {
      enbaleDisableStatus,
      productTypeTag,
      blueColor,
      tablejson,
      operation: [
        {
          name: this.$t('Common.edit'),
          icon: 'icon-edit_16',
          type: 'edit',
          hide: () => {
            return !this.updateRole
          }
        },
        {
          name: this.$t('Common.detail'),
          icon: 'icon-detail_16',
          type: 'detail',
          hide: () => {
            return !this.detailRole
          }
        },
        {
          name: this.$t('Common.delete'),
          icon: 'icon-del_16',
          type: 'delete',
          hide: () => {
            return !this.deleteRole
          }
        }
      ],
      productInfo: {},
      tableData: [],
      total: 0,
      productId: this.$route.query.id,
      productKey: this.$route.query.pk,
      version: '',
      importLoading: false,
      row: null,
      visible: false,
      tslVersionId: '',
      detailVisible: false,
      publishLoading: false
    }
  },
  created() {
    this.getProductDetail()
    this.search()
  },
  computed: {
    roleChildList() {
      let path = '/product/model'.toLowerCase()
      let productModelRole = getRoute(path, this.$store.state.menus) || {}
      let draftRole = getRoleByOperationCode(productModelRole.childList, 'draft')
      return draftRole && draftRole.isPermission === 'Y' ? draftRole.childList : []
    },
    // 添加
    addRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'tsl_add')
      return val ? val.isPermission == 'Y' : false
    },
    // 编辑
    updateRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'tsl_update')
      return val ? val.isPermission == 'Y' : false
    },
    // 详情
    detailRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'tsl_detail')
      return val ? val.isPermission == 'Y' : false
    },
    // 删除
    deleteRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'tsl_del')
      return val ? val.isPermission == 'Y' : false
    },
    // 导入
    importRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'import')
      return val ? val.isPermission == 'Y' : false
    },
    // 发布
    publishRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'publish')
      return val ? val.isPermission == 'Y' : false
    }
  },
  filters: {
    format,
    formatTime
  },
  methods: {
    async search(params) {
      params = params || {
        productKey: this.productKey,
        draft: true,
        version: this.version
      }
      return this.$ajax
        .get(this.$api.product.product_tsl_function_list, params)
        .then((res) => {
          if (res.data) {
            this.tslVersionId = res.data.id
            this.tableData = res.data.functions
          }
        })
        .catch(() => {})
    },
    getProductDetail() {
      const params = {
        id: this.$route.query.id
      }
      return this.$ajax
        .get(this.$api.product.product_detail, params)
        .then((res) => {
          this.productInfo = res.data
        })
        .catch(() => {})
    },
    onVersionChange(versionId) {
      const params = {
        productKey: this.productKey,
        draft: versionId ? false : true,
        version: this.version
      }
      this.search(params)
    },
    handleCancel() {
      this.$confirm(`${this.$t('Common.cancelPublish')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: this.$t('Common.confirm'),
        cancelButtonText: this.$t('Common.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.$router.push({
            name: 'ProductDetail',
            query: {
              ...this.$route.query
            }
          })
        })
        .catch(() => {})
    },
    handlePublish() {
      this.$confirm(`${this.$t('Common.confirmPublish')}`, `${this.$t('Common.tips')}`, {
        confirmButtonText: this.$t('Common.confirm'),
        cancelButtonText: this.$t('Common.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.publishLoading = true
          const params = {
            id: this.tslVersionId
          }
          this.$ajax
            .post(this.$api.product.product_tsl_publish, params)
            .then(() => {
              this.$message({
                type: 'success',
                message: this.$t('Common.operationSuccess'),
                onClose: () => {
                  this.$router.push({
                    name: 'ProductDetail',
                    query: {
                      ...this.$route.query
                    }
                  })
                }
              })
            })
            .catch(() => {})
            .finally(() => {
              this.publishLoading = false
            })
        })
        .catch(() => {})
    },
    handleAdd() {
      this.row = null
      this.visible = true
    },
    handleEdit(row) {
      this.row = row
      this.visible = true
    },
    handleImport({ file }) {
      this.importLoading = true
      const formData = new FormData()
      formData.append('file', file)
      formData.append('draftId', this.tslVersionId)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax
        .post(this.$api.product.product_tsl_import, formData, config)
        .then((res) => {
          this.$message.success(`${this.$t('Common.operationSuccess')}`)
          if (res.data) {
            this.tslVersionId = res.data.id
            this.tableData = res.data.functions
          }
        })
        .catch(() => {})
        .finally(() => {
          this.importLoading = false
        })
    },
    handleDelete(row) {
      let msg = ''
      let queryApi = ''
      if (row.type === 'property') {
        msg = this.$t('Product.tips5')
        queryApi = this.$api.product.product_tsl_property_delete
      } else if (row.type === 'service') {
        msg = this.$t('Product.tips6')
        queryApi = this.$api.product.product_tsl_service_delete
      } else if (row.type === 'event') {
        msg = this.$t('Product.tips7')
        queryApi = this.$api.product.product_tsl_event_delete
      }
      this.$confirm(msg, `${this.$t('Common.tips')}`, {
        confirmButtonText: this.$t('Common.confirm'),
        cancelButtonText: this.$t('Common.cancel'),
        type: 'warning'
      })
        .then(() => {
          let params = {
            tslVersionId: this.tslVersionId,
            identifier: row.identifier
          }
          this.$ajax
            .post(queryApi, params)
            .then(() => {
              this.$message.success(`${this.$t('Common.delSuccess')}`)
              this.search()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleDetail(row) {
      this.row = row
      this.detailVisible = true
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'detail':
          this.handleDetail(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoepd>
.info-header {
  display: flex;
  h3 {
    margin-right: 8px;
    font-size: 24px;
    color: #333333;
  }
}
.info-tag {
  margin-top: 12px;
  .hl-tag {
    margin-right: 8px;
  }
}
.bottom-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    align-content: center;
  }
  h3 {
    margin-right: 16px;
    line-height: 32px;
    font-size: 16px;
    color: #333333;
  }
  .opts {
    display: flex;
    .hl-button {
      margin-right: 8px;
    }
    & > :last-child {
      margin-right: 0;
    }
  }
}
.hl-alert {
  margin-top: 16px;
  margin-bottom: 8px;
}
</style>
